<glxy-page [isLoading]="isLoading()">
  <glxy-page-toolbar>
    <glxy-page-title>{{ 'PERFORMANCE.REPUTATION.AUTO_REVIEW_RESPONSE.SETTINGS.TITLE' | translate }}</glxy-page-title>
    <glxy-page-nav>
      <glxy-page-nav-button
        [useHistory]="true"
        [useRelativePath]="true"
        [previousPageUrl]=previousPageUrl
      ></glxy-page-nav-button>
    </glxy-page-nav>
  </glxy-page-toolbar>
  <glxy-page-wrapper widthPreset="narrow">
      <form [formGroup]="settingsForm">
        <mat-card>
          <mat-card-header>
            <mat-card-title>{{ 'PERFORMANCE.REPUTATION.AUTO_REVIEW_RESPONSE.SETTINGS.CARD_TITLE' | translate }}</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <glxy-form-field size="medium">
              <mat-select placeholder="--" formControlName="rating">
                <mat-option *ngFor="let option of starOptions" [value]="option.value">
                  {{ option.label | translate }}
                </mat-option>
              </mat-select>
              <glxy-hint>
                {{ 'PERFORMANCE.REPUTATION.AUTO_REVIEW_RESPONSE.SETTINGS.RATING_HINT' | translate }}
              </glxy-hint>
            </glxy-form-field>

            <glxy-form-field>
              <div class="checkbox-group">
                <glxy-label style="padding-bottom: 6px">{{ 'PERFORMANCE.REPUTATION.AUTO_REVIEW_RESPONSE.SETTINGS.PLATFORMS_LABEL' | translate }}</glxy-label>
                @for (source of availableSources; track source.key) {
                  <mat-checkbox
                    [checked]="isSourceSelected(source.key)"
                    (change)="toggleSource(source.key)">
                    {{ source.label | translate }}
                  </mat-checkbox>
                }
              </div>
            </glxy-form-field>

            <div class="delay-selector">
              <glxy-form-field style="width: 100px">
                <input type="number" placeholder="--"  [min]="minLimit" [max]="maxLimit" matInput formControlName="delayValue"/>
              </glxy-form-field>
              <glxy-form-field size="medium" style="width: 100px">
                <mat-select placeholder="--" formControlName="delayUnit">
                  <mat-option *ngFor="let option of delayOptionsInPeriod" [value]="option.value">
                    {{ option.label | translate }}
                  </mat-option>
                </mat-select>
              </glxy-form-field>
              <glxy-label style="padding-bottom: 24px">{{ 'PERFORMANCE.REPUTATION.AUTO_REVIEW_RESPONSE.SETTINGS.DELAY_SUFFIX' | translate }}</glxy-label>
            </div>

            <mat-card class="asst-details-card" appearance="outlined">
              <mat-card-content class="asst-details-content">
                <glxy-avatar
                  width="52"
                  class="assistant-avatar"
                  [name]="assistantName()"
                  [src]="assetPath('ai-reputation.jpg')"
                ></glxy-avatar>
                <div class="assistant-name">
                  @if(assistantName()){
                    <glxy-label>{{ assistantName() }}</glxy-label>
                    <glxy-label-hint>{{ 'PERFORMANCE.REPUTATION.AUTO_REVIEW_RESPONSE.SETTINGS.ASSISTANT_ROLE' | translate }}</glxy-label-hint>
                  }@else{
                    <glxy-loading-spinner size="small"></glxy-loading-spinner>
                  }
                </div>
                <button (click)="goToConfigPage()" style="margin-left: auto" mat-stroked-button>{{ 'PERFORMANCE.REPUTATION.AUTO_REVIEW_RESPONSE.SETTINGS.CONFIGURE_BUTTON' | translate }}</button>
              </mat-card-content>
            </mat-card>
          </mat-card-content>
        </mat-card>
      </form>
    <glxy-sticky-footer>
      <button
        mat-flat-button
        color="primary"
        [disabled]="isLoading() || !isFormDirty()"
        (click)="onSave()"
      >
        <glxy-button-loading-indicator [isLoading]="isLoading()">
          {{ 'PERFORMANCE.REPUTATION.AUTO_REVIEW_RESPONSE.SETTINGS.SAVE_BUTTON' | translate }}
        </glxy-button-loading-indicator>
      </button>
      <button
        mat-stroked-button
        (click)="goToConfigPage()"
        [disabled]="isLoading()"
      >
        {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
      </button>
    </glxy-sticky-footer>
  </glxy-page-wrapper>
</glxy-page>
